import useParseHtml from './use-parse-html'

export default useParseHtml
